import type * as React from "react";

import type { IconComponentProps } from "../icon-types.ts";

const GOOGLE_BRAND = {
  blue: "#4285F4",
  green: "#34A853",
  yellow: "#FBBC05",
  red: "#EA4335",
} as const;

export function GoogleLogo({
  size = 24,
  ref,
  ...props
}: IconComponentProps): React.ReactElement {
  const { color: _color, strokeWidth: _strokeWidth, ...rest } = props;
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path
        fill={GOOGLE_BRAND.blue}
        d="M23.52 12.273c0-.851-.076-1.669-.218-2.455H12v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.011h3.878c2.268-2.089 3.578-5.165 3.578-8.82Z"
      />
      <path
        fill={GOOGLE_BRAND.green}
        d="M12 24c3.24 0 5.956-1.075 7.941-2.907l-3.877-3.011c-1.075.72-2.449 1.145-4.064 1.145-3.125 0-5.771-2.111-6.715-4.947H1.276v3.109A11.995 11.995 0 0 0 12 24Z"
      />
      <path
        fill={GOOGLE_BRAND.yellow}
        d="M5.285 14.28A7.213 7.213 0 0 1 4.909 12c0-.791.136-1.56.376-2.28V6.611H1.276A11.995 11.995 0 0 0 0 12c0 1.936.464 3.769 1.276 5.389l4.009-3.109Z"
      />
      <path
        fill={GOOGLE_BRAND.red}
        d="M12 4.773c1.762 0 3.344.605 4.587 1.794l3.442-3.442C17.951 1.19 15.235 0 12 0 7.31 0 3.253 2.69 1.276 6.611l4.009 3.109C6.229 6.884 8.875 4.773 12 4.773Z"
      />
    </svg>
  );
}
